var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Header'),_c('div',{staticClass:"dWrap"},[_c('div',{staticClass:"content"},[_c('NewsListTabs',{attrs:{"tTitle":_vm.tTitle,"tabsData":_vm.tabsData,"active":_vm.active},on:{"changeActive":_vm.changeActive,"currentChange":_vm.currentChange,"handleSizeChange":_vm.handleSizeChange}})],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }